import { useAppState } from './useAppState';
import { dutchTranslations, englishTranslations } from '../data/translations';

export function useTranslation() {
  const { state } = useAppState();
  const language = state.userPreferences.preferredLanguage;

  const t = (key: string, params?: { [key: string]: string }): string => {
    // Select the appropriate translation set
    const translations = language === 'en' ? englishTranslations : dutchTranslations;
    
    // Get the translation
    let translation = translations[key] || key;
    
    // Replace parameters if provided (e.g., {brand} and {type})
    if (params) {
      Object.keys(params).forEach((paramKey) => {
        translation = translation.replace(`{${paramKey}}`, params[paramKey]);
      });
    }
    
    return translation;
  };

  return { t, language };
}
